const HomeHero = () => {
  return (
    <section
      id="intro"
      className="home-hero"
      style={{
        backgroundImage:
          "linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url('/img/topbanner.jpg')",
      }}
    >
      <div className="container home-hero-inner">
        <p className="home-hero-pretitle">
          Shopify Store Setup for Small Businesses in India
        </p>

        <h2 className="home-hero-title">
          Stop losing orders in WhatsApp chats.
          <br />
          Turn your business into a proper online store.
        </h2>

        <p className="home-hero-subtitle">
          We help small businesses move from messy chats to a clean Shopify
          store - so you never miss a customer again.
        </p>

        <div
          style={{
            marginBottom: "15px",
            opacity: 0.9,
            fontSize: 18,
          }}
        >
          ✔ Done-for-you setup &nbsp; | &nbsp; ✔ No tech skills needed &nbsp; |
          &nbsp; ✔ Go live in 5–7 days
        </div>

        <a className="btn btn-md btn-color home-hero-button" href="#pricing">
          Get My Store Now →
        </a>

        <p className="home-hero-secondary-cta">
          <a href="#contact-us">Book a free call</a>
        </p>

        <p
          style={{
            fontSize: "16px",
            marginTop: "10px",
            color: "white",
          }}
        >
          Limited slots this month - we work with a few businesses at a time
        </p>
      </div>
    </section>
  );
};

export default HomeHero;
